import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DocumentTable from "./documentTable"

const DocmmentList = ({ user_type }) => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Sample Documents"} />
          <DocumentTable user_type={user_type} />
        </Container>
      </div>
    </>
  )
}

export default DocmmentList
